var _symbol, _symbol2, _symbol3, _defs, _symbol4, _use;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLightsnowandthunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "snowflake"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#47c0e3",
    d: "M11.68,4.47H8.85L10.27,2A1.35,1.35,0,1,0,7.93.67L6.51,3.12,5.1.67A1.35,1.35,0,0,0,3.26.18,1.35,1.35,0,0,0,2.76,2L4.18,4.47H1.35a1.35,1.35,0,1,0,0,2.7H4.18L2.76,9.62a1.35,1.35,0,0,0,.49,1.84A1.39,1.39,0,0,0,5.1,11L6.51,8.52,7.93,11a1.35,1.35,0,1,0,2.34-1.35L8.85,7.17h2.83a1.35,1.35,0,1,0,0-2.7Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightning"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffdd15",
    points: "19.6 23.42 12.74 20.39 15.55 5 5 24.49 12.08 27.51 7.49 45 19.6 23.42"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7,5A23.94,23.94,0,0,0,34.37,18.05a9.9,9.9,0,0,0-12.78,5.56,15,15,0,0,0-1.71-.1A14.81,14.81,0,0,0,9.2,28,14.63,14.63,0,0,0,5,38.17v.21A14.83,14.83,0,0,0,19.88,53.06H75.59a14.3,14.3,0,0,0,3.67-28.14A23.93,23.93,0,0,0,55.7,5Z"
  }), /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 14,
    width: 85,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAkCAMAAAAkYj0PAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURSgoKExpcaCgoFBQUG5ublBQUISEhI1fsT0AAAAHdFJOUxsACBsPFRpGXuFgAAABWElEQVRIx7XV25bDIAgF0BMu/v8nF/E+iWlqHNKVN3cpIMXxL4GFM3SQfTazkUyxk63oLYwlVSy2silXkS/wUrZS2a3ZCn1zsdSw7UUYijuHsTa1IvfwWrbSXLkc4N9r27JViwmM1UtWXA3hohQ41m6vl8FQZi7wu2z7KXPW4uRiZS+2AmdXN7DdQEQWQHYHlt6z0dXBBa2xeeVktiZc1jDoF5eGkI4d4MjKc7cNbZ3bqjocLLx5oPDYTaIftcfvAvcs2GFxVsJTOP1wO1jGdUSLaz/DWA1Tl45+Tkqul2ArcPzayGq8JafOUffP3TUp6JQs+Rptc6vtmtBkUw+dv0NzWG0PYf8O7Ym09+ITXyXOPZqEX95aFe3PKxRsL2XV3HR+ZALirPSF0ceHp6F51WBv1A22VaW2GHWzWvat8LOAPf4CrjrA+neNK7+PQBf/DmmLrId09/QDWyESBsibwBUAAAAASUVORK5CYII="
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "lightning_37_51_1_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lightning",
    fill: "black",
    stroke: "black",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(37,51) scale(1,1)"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "s33"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#lightning_37_51_1_1_4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cloud",
    fill: "#cccccc",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(3,18) scale(1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lightning",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(37,51) scale(1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#snowflake",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(26,88) scale(1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#snowflake",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    transform: "translate(58,79) scale(1,1)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s33",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightsnowandthunder);
export default __webpack_public_path__ + "static/media/lightsnowandthunder.be72ca9ded55bb8cb829d66548190516.svg";
export { ForwardRef as ReactComponent };